import { useSelector } from 'react-redux';
import { AppStateTypes } from '../../store/appStateTypes';

export const useSubscriptionState = () => {
  const { currentSubscription, hasSubscription } = useSelector((state: AppStateTypes) => state.subscription);

  // Функция для проверки фич подписки
  const hasFeature = (feature: string): boolean => {
    if (!hasSubscription || !currentSubscription?.plan) {
      return false;
    }
    return currentSubscription.plan.features.includes(feature);
  };

  return {
    currentSubscription,
    hasSubscription,
    hasFeature,
  };
};